import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13 4h5v16H6V4h1v9.04c0 .408.268.77.669.906.4.135.847.012 1.112-.306L10 12.177l1.22 1.463c.264.318.71.44 1.111.306A.963.963 0 0013 13.04V4zM9 4h2v6.303l-.22-.263a1.016 1.016 0 00-.78-.36c-.304 0-.591.133-.78.36l-.22.263V4zm3-2h6a2 2 0 012 2v16a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h6z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
